import { useBoundStore } from '../../../../stores';
import { Delete, Edit, LinkOff, Visibility } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import PermissionToRender from '../../../../components/Permission/PermissionToRender';
import { useNavigate } from 'react-router-dom';

function Columns(handleDelete, handleRelation) {
  const navigate = useNavigate();
  const textPool = useBoundStore((state) => state.textPool);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  return [
    {
      field: 'companyName',
      headerName: "Şirket Adı",
      width: 250,
    },
    {
      field: 'address',
      headerName: "Adres",
      width: 200,
    },
    { field: 'description', headerName: 'Açıklama', width: 250 },
    // {
    //   field: 'vehicle_Id',
    //   headerName: textPool['Araç Plaka'],
    //   width: 200,
    //   renderCell: (data) => {
    //     return data.row.vehicle_Id ? (
    //       data.row.vehicle_Id
    //     ) : (
    //       <span className="font-bold">Eşleşme Yok</span>
    //     );
    //   },
    // },
    /* { field: 'dataProtocol', headerName: 'Protokol', width: 150 },
    { field: 'dataProtocolVersion', headerName: 'Protokol Versiyonu', width: 150 },
    { field: 'company', headerName: 'Şirket', width: 150 },  */
    {
      field: 'createdAt',
      headerName: textPool['Oluşturma Tarihi'],
      width: 150,
      notFilter: true,
      renderCell: (data) =>
        data.row.createdAt ? (
          <div>
            {data?.row?.createdAt
              ? new Date(data?.row?.createdAt).toLocaleString('tr')
              : ''}
          </div>
        ) : (
          <span className="font-bold">Eşleşme Yok</span>
        ),
    },
    {
      field: 'actions',
      headerName: 'İşlemler',
      width: 100,
      sortable: false,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}>
              <IconButton
                onClick={() => {
                  navigate(
                    `/definitions/devices/device-record/${params.row.device_Id}`,
                  );
                }}
              >
                <Visibility />
              </IconButton>
            </PermissionToRender> */}

            <IconButton
              onClick={() => {
                navigate(`/definitions/companies/#${params.row.id}`);
                toggleLeftDrawer();
              }}
            >
              <Edit />
            </IconButton>


            {/* <IconButton
              disabled={!params.row.id}
              onClick={() => handleRelation(params.row)}
            >
              <LinkOff />
            </IconButton> */}

            <IconButton onClick={() => handleDelete(params.row)}>
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];
}
export { Columns as columns };
